<script>
  import PdfLightbox from '@components/messenger/previews/PdfLightbox.svelte';

  export let url;
  export let onClose;
</script>

<PdfLightbox {url} {onClose} />
